"use client";

import { Box, Chip, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

export default function LoginIntro() {
  const t = useTranslations("auth");
  const highlights = [
    {
      title: t("loginIntroFeature1Title"),
      body: t("loginIntroFeature1Body"),
    },
    {
      title: t("loginIntroFeature2Title"),
      body: t("loginIntroFeature2Body"),
    },
    {
      title: t("loginIntroFeature3Title"),
      body: t("loginIntroFeature3Body"),
    },
  ];

  return (
    <Stack flex={1} spacing={3}>
      <Chip
        label={t("loginIntroBadge")}
        color="secondary"
        sx={{ alignSelf: "flex-start", fontWeight: 600 }}
      />
      <Typography variant="h3" fontWeight={800} color="text.primary">
        {t("loginIntroTitle")}
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 520 }}>
        {t("loginIntroSubtitle")}
      </Typography>

      <Stack spacing={2}>
        {highlights.map((item) => (
          <Box key={item.title} sx={{ display: "flex", gap: 2 }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                mt: 1,
                background: "linear-gradient(135deg, #22c55e 0%, #3b82f6 100%)",
                flexShrink: 0,
              }}
            />
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.body}
              </Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
}
